// extracted by mini-css-extract-plugin
var _1 = "ClampingText-moduleclampingText__ANX4H";
var _2 = "ClampingText-moduleshowMore__gZsCz";
export { _1 as "clampingText", _2 as "showMore" }
